import en, {merged} from "./en"
import fr, {merged as mergedfr} from "./fr"

en.merged = merged
fr.merged = mergedfr

export default {
  en, fr
}